import { useTranslation } from 'react-i18next';

import BalanceCom from '@/components/BalanceCom';
import Icon from '@/components/Icon';
import LpTokenImg from '@/components/LpTokenImg';
import arrows from '@/image/arrows.svg';

const MyLp = ({ fromTokenLogo, toTokenLogo, fromTokenSymbol, toTokenSymbol, balanceLp, balanceLpLod }: { balanceLpLod: boolean, balanceLp: bigint, fromTokenLogo: string, toTokenLogo: string, fromTokenSymbol: string, toTokenSymbol: string }) => {
    const { t } = useTranslation()
    return <div className="p-3.75 border border-ee bg-white rounded-5  text-sm text-mainBlack cursor-pointer">
        <div className="flex items-center justify-between pb-2.5">
            <p className="font-medium ">{t('mobility.your')}LP</p>
            <Icon className='w-5 -rotate-90' src={arrows} />
        </div>
        <div className='flex items-center justify-between'>
            <div className='flex items-center'>
                <div className='mr-5'>
                    <LpTokenImg className='w-6 ' fromTokenLogo={fromTokenLogo} toTokenLogo={toTokenLogo} />
                </div>
                <div>
                    {fromTokenSymbol} / {toTokenSymbol}
                </div>
            </div>
            <BalanceCom balance={balanceLp} loading={balanceLpLod} />
        </div>
    </div>
}

export default MyLp